export default "__VITE_ASSET__CkB6p3n2__"